import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import "./context_components.css";
import { Collapse } from "@mui/material";

export default function ColorPicker(props) {
  const [openSelector, setOpenSelector] = useState(false);
  const { color } = props;

  useEffect(() => {}, [color])

  const handleColorChange = (newColor) => {
    const rgbaColor = `rgba(${newColor.rgb.r}, ${newColor.rgb.g}, ${newColor.rgb.b}, ${newColor.rgb.a})`;
    props.changeColor({
      type: props.type,
      color: rgbaColor
    });
  };

  return (
    <div>
      <div
        className='picker'
        style={{ backgroundColor: color }}
        onClick={() => setOpenSelector(!openSelector)}
      >
      </div>
      <div className={openSelector ? "picker-selector" : "close-selector"}>
          <SketchPicker color={color} onChange={handleColorChange} />
        </div>
    </div>
  );
}
